
import { defineComponent, onMounted, ref, computed } from "vue";
import Title from "@/layouts/reusable/Title.vue";
import Vehicle from "@/components/new/Vehicle.vue";
import Stepper from "@/core/services/etc/Steppers";
import setVehicle from "@/core/services/car/Vehicles";
import BaiSkeletonVehicle from "@/layouts/skeleton/vehicle.vue";
import { store } from "@/store";
import router from "@/router";
import head_mobile from '@/layouts/head_mobile.vue';

export default defineComponent({
  components: {
    Title,
    Vehicle,
    BaiSkeletonVehicle,
    head_mobile
  },

  setup() {
    const isLoaded = ref(false);

    const current = computed(() => {
      return store.state.steppers.stepper;
    });

    onMounted(() => {
      setTimeout(() => {
        isLoaded.value = true;
      }, 500);

      const routeValue = {
        vehicle: "active",
        driver: "",
        compare: "",
        cover: "",
      };
      Stepper.setVehicleDetails(routeValue);
      const myStorage = window.localStorage.getItem("customer_detatils");
      if (myStorage) {
        const vehicle = JSON.parse(myStorage);
        setVehicle.setVehicle(vehicle);
        setVehicle.getVehicleDetails(vehicle);
      }

      const is_lr = router.currentRoute.value.query ? router.currentRoute.value.query.is_lr : null;

      if(router.currentRoute.value && router.currentRoute.value.query.name && !is_lr) {
        const customerName = router.currentRoute.value.query.name.toString();
        const customerEmail = router.currentRoute.value.query.email?.toString();
        const phone_number:any = router.currentRoute.value.query.pn?.toString().replace('?', '');
        const country_code = router.currentRoute.value.query.country_code?.toString().replace('?', '');

        const storeVehicle = store.state.vehicles.vehicle;
        const vehiclePage = {
          name: customerName,
          email: customerEmail,
          phone_number: parseInt(phone_number),
          phone_country_code: `+${country_code?.replace(' ', '')}`,
          car_year: storeVehicle.car_year,
          is_new: storeVehicle.is_new,
          manufacturer_id: storeVehicle.manufacturer_id,
          model_id: storeVehicle.model_id,
          trim_level_id: storeVehicle.trim_level_id,
          registration_emirate: storeVehicle.registration_emirate,
          car_values: storeVehicle.car_values,
          is_car: storeVehicle.is_car,
          lead_source: storeVehicle.lead_source,
          btm_source: storeVehicle.btm_source,
          utm_source: storeVehicle.utm_source,
          utm_medium: storeVehicle.utm_medium,
          utm_campaign: storeVehicle.utm_campaign,
          utm_content: storeVehicle.utm_content,
          utm_term: storeVehicle.utm_term,
          sid: storeVehicle.sid,
          customer_source_url: storeVehicle.customer_source_url,
          preferred_language: window.localStorage.getItem('language')
        };
        setVehicle.setVehicle(vehiclePage);

        
      }
    });

    return {
      current,
      isLoaded,
    };
  },
});
